exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scheduler-item{margin:0 0 45px}.scheduler-item h2,.scheduler-item h3{margin:0}.scheduler-item h2{margin:0 0 10px;opacity:.75}.scheduler-item .speaker-item{margin-top:15px}.scheduler-item .hoster-item{margin-top:5px}.scheduler-item .text{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/scheduler/scheduler.scss
// module id = 517
// module chunks = 0